import React from 'react';
import { useSeo } from '../hooks/useSeo';
import Hero from '../components/landing/Hero';
import About from '../components/landing/About';
import Schedule from '../components/landing/Schedule';
import Community from '../components/landing/Community';
import VideoShowcase from '../components/landing/VideoShowcase';
import Footer from '../components/landing/Footer';

const HomePage: React.FC = () => {
  useSeo();

  return (
  <div className="min-h-screen bg-[#0a0815] text-white">
    <Hero />
    <About />
    <Schedule />
    <Community />
    <VideoShowcase />
    <Footer />
  </div>
  );
};

export default HomePage;
